export default [
  {
    path: "/sessions",
    name: "sessions",
    component: () => import("@/views/pages/sessions/Sessions.vue"),
    meta: {
      hasPermission:true,

      pageTitle: "جلسات",
      breadcrumb: [
        {
          text: "جلسات",
          active: true,
        },
      ],
    },
  },

  {
    path: "/sessions/add",
    name: "add-session",
    component: () =>
      import("@/views/pages/sessions/session-form/SessionForm.vue"),
    meta: {
      hasPermission:true,

      pageTitle: "اضافه کردن جلسه",
      breadcrumb: [
        {
          text: "جلسات",
          to: "/sessions",
        },
        {
          text: "اضافه کردن جلسه",
          active: true,
        },
      ],
    },
  },
  {
    path: "/sessions/:session_id",
    name: "show-session",
    component: () =>
      import(
        "@/views/pages/courses/show-course/session-content/SessionContent.vue"
      ),
    meta: {
      notNeedLogin:true,
      pageTitle: "جزئیات جلسه",
      breadcrumb: [
        {
          text: "جلسات",
          to: "/sessions",
        },
        {
          hasId: true,
          text: "جزئیات جلسه",
          active: true,
        },
      ],
    },
  },
  {
    path: "/sessions/:id/edit",
    name: "edit-session",
    component: () =>
      import("@/views/pages/sessions/session-form/SessionForm.vue"),
    meta: {
      hasPermission:true,

      pageTitle: "ویرایش کردن جلسه",
      breadcrumb: [
        {
          text: "جلسات",
          to: "/sessions",
        },
        {
          text: "ویرایش کردن جلسه",
          active: true,
        },
      ],
    },
  },

];
